// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Nh5Q","list":"styles_list__wVpSL"};